import {
  CustomSelectChoice,
  FieldAnswer,
  FieldType,
  SingleChoiceField,
} from '@app/api';
import { v4 as uuidV4 } from 'uuid';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmitType } from '../CustomForm/fieldConfigurations';
import { SingleChoiceFieldForm } from '../CustomForm/FormField/SingleChoiceFieldForm';

const JOB_CHOICE_REF = 'workingInTech';
const JOB_CHOICES = [
  'ACADEMIC',
  'PRODUCT',
  'DEVELOPMENT',
  'MARKETING',
  'RESEARCH',
  'SALES',
];
interface Props {
  onJobChoiceSubmit: (answer: FieldAnswer) => void;
}

export const ParticipantJobChoice = ({ onJobChoiceSubmit }: Props) => {
  const { t } = useTranslation();

  const field = useMemo(() => {
    const choices = [
      ...JOB_CHOICES.map((job) => ({
        ref: job,
        label: t(`jobSelection.screening.jobs.${job}`),
      })),
      {
        ref: CustomSelectChoice.Other,
        label: t('jobSelection.screening.jobs.other'),
      },
      {
        ref: CustomSelectChoice.None,
        label: t('jobSelection.screening.jobs.none'),
      },
    ];

    const singleChoiceField: SingleChoiceField = {
      id: uuidV4(),
      ref: JOB_CHOICE_REF,
      title: t('jobSelection.screening.title'),
      type: FieldType.SINGLE_CHOICE,
      properties: {
        randomize: false,
        choices,
      },
      validation: {
        required: true,
      },
    };

    return singleChoiceField;
  }, [t]);

  return (
    <SingleChoiceFieldForm
      field={field as SingleChoiceField}
      onSubmit={onJobChoiceSubmit}
      submitType={SubmitType.CONTINUE}
    />
  );
};
